window.product_is_unavailable = false;

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true }),
        );

        this.setupTabsListener();
        this.setChoosenOption();
        this.setupStickyConfig();
        this.setupStickyMobileConfig();
        this.initMobileSliderDragEvent();
        this.setupSmartbaseWidths();
        this.checkProductReviewAndSample();
        this.handleReviewBlockAndSku();
      }

      handleReviewBlockAndSku() {
        const reviewWrapper = document.querySelector(".review-block__wrapper");
        const reviewContainer = document.querySelector(
          ".container-review-block",
        );
        const sku = document.querySelector(".product__sku");
        const deliveryChecker = document.querySelector(".configuration-light");
        const stockIndicator = document.querySelector(".stock-indicator-light");

        // Always ensure skuStockWrapper exists
        let skuStockWrapper = document.querySelector(".sku__stockindicator");
        let skuNewStockWrapper = document.querySelector(
          ".product__title .product__title-header",
        );

        if (!skuStockWrapper) {
          skuStockWrapper = document.createElement("div");
          skuStockWrapper.className = "sku__stockindicator";
        }

        // Always ensure existing elements are removed from previous parents
        if (sku && sku.parentNode) {
          sku.parentNode.removeChild(sku);
        }
        if (stockIndicator && stockIndicator.parentNode) {
          stockIndicator.parentNode.removeChild(stockIndicator);
        }

        // Always add SKU and stock indicator to wrapper
        if (sku) {
          skuNewStockWrapper.appendChild(sku);
        }
        if (stockIndicator) {
          skuStockWrapper.appendChild(stockIndicator);
        }

        // Determine where to place the wrapper based on review wrapper state
        if (
          reviewWrapper &&
          (!reviewWrapper.hasChildNodes() ||
            reviewWrapper.textContent.trim() === "")
        ) {
          if (deliveryChecker) {
            deliveryChecker.appendChild(skuStockWrapper);
          }
        } else {
          if (deliveryChecker) {
            deliveryChecker.appendChild(skuStockWrapper);
          }
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.stickyAtcObserver?.disconnect();
        this.stickyAtcBodyObserver?.disconnect();
        this.stickyAtcHeaderObserver?.disconnect();
        window.removeEventListener("resize", this.onStickyAtcResize);
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel"),
            ),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage,
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
            this.setChoosenOption();
            this.setupStickyMobileConfig();
            if (window.product_is_unavailable) this.setUnavailable();
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
            this.setChoosenOption();
            this.setupStickyMobileConfig();
            if (window.product_is_unavailable) this.setUnavailable();
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.error("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        let selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]",
        )?.innerHTML;

        if (!selectedVariant) {
          selectedVariant = productInfoNode.querySelector(
            "variant-radios [data-selected-variant]",
          )?.innerHTML;
        }

        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          const variantID = new URLSearchParams(window.location.search).get(
            "variant",
          );
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variantID);
          // this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false,
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`,
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden"),
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === "",
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden"),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
          );

          this.setChoosenOption();
          this.setupStickyMobileConfig();
          if (window.product_is_unavailable) this.setUnavailable();

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`,
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`,
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable,
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]"),
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]"),
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true,
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            ).classList.add("hidden"),
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      initStockMovement() {
        this.moveStockLocation();

        window.addEventListener("resize", () => {
          this.moveStockLocation();
        });
      }

      moveStockLocation() {
        const width = window.innerWidth;
        // let targetSelector =
        //   width >= 1280 ? ".product__title" : ".container-review-block";
        const target = document.querySelector(".container-review-block");
        const stock = document.querySelector(".stock-indicator-light");

        // if (
        //   targetSelector == ".container-review-block" &&
        //   !target?.querySelector(".review-block__wrapper")?.hasChildNodes()
        // )
        //   return;

        if (target && stock) {
          stock.classList.add("stock-indicator-light--moved");
          target.appendChild(stock);
        }
      }

      setChoosenOption() {
        const selectors = [
          {
            class: ".swatch--fabric",
            title: "Colour",
          },
          {
            class: ".swatch--feet",
            title: "Type",
          },
          {
            class: ".swatch--version",
            title: "Version",
          },
          {
            class: ".swatch--rails",
            title: "Rails",
          },
          {
            class: ".swatch--wood-colour",
            title: "Colour",
          },
          {
            class: ".swatch--material",
            title: "Material",
          },
          {
            class: ".swatch--mattress",
            title: "Mattress",
          },
          {
            class: ".swatch--thread-count",
            title: "Threads",
          },
          {
            class: ".swatch--handset",
            title: "Handset",
          },
          {
            class: ".swatch--sides",
            title: "Sides",
          },
          {
            class: ".swatch--colour",
            title: "Colour",
          },
          {
            class: ".swatch--type",
            title: "Type",
          },
          {
            class: ".swatch--headboard",
            title: "Design",
          },
          {
            class: ".swatch--firmness",
            title: "Firmness",
          },
          {
            class: ".swatch--system",
            title: "System",
          },
        ];

        selectors.forEach((selector) => {
          const selected = document.querySelector(
            `${selector.class} .p-custom-swatch input[type="radio"]:checked`,
          );
          if (selected) {
            const inputLabelSelector = selected
              .getAttribute("id")
              .toString()
              .trim()
              .replace(/\n/g, "");
            const inputLabel = document.querySelector(
              `${selector.class} [for^="${inputLabelSelector}"]`,
            );

            if (inputLabel) {
              const value = inputLabel
                .getAttribute("data-value")
                .toString()
                .trim();
              const newValue = selected.value
                .replace("Fabric", "- Fabric")
                .replace("Leather", "- Leatherette");
              this.setChoosenOptionLabel(selector, newValue);
            }
          }
        });
      }

      setChoosenOptionLabel(selector, value) {
        const option = document.querySelector(`${selector.class}`);
        if (option) {
          // Remove first the choosen label if it exist
          option.querySelector(".swatch--choosen")?.remove();

          // Create the choosen label
          const choosenLabel = document.createElement("span");
          choosenLabel.classList.add("swatch--choosen");
          // choosenLabel.innerHTML = `<b>${selector.title}:</b> ${value}`;
          choosenLabel.innerHTML = `<b>Selected:</b> ${value}`;

          // Append the choosen label
          const optionLegend = option.querySelector("legend");
          optionLegend?.appendChild(choosenLabel);
          optionLegend?.classList.add("p-custom-label--choosen");
        }
      }

      /**
       * Sticky add-to-cart bar visibility + position.
       *
       * - Shown whenever the main add-to-cart button is out of view (including
       *   when it's hidden behind the sticky header), via IntersectionObserver.
       * - Positioned directly under the sticky header using --sticky-atc-top on
       *   :root. The value is only recalculated when the bar appears, when the
       *   header hides/reveals while the bar is showing, and on resize.
       * - refreshStickyConfig() is re-run by setupStickyMobileConfig() whenever
       *   the bar is rebuilt, as a product swap replaces the observed button.
       * - Only shown once the button has scrolled up past the nav, never while
       *   it's still further down the page (so it's also hidden on load at the
       *   top of the page).
       */
      setupStickyConfig() {
        // The header section itself has no height: the visible nav is the
        // position: fixed <sticky-header> inside it, so measure that instead.
        const headerSection = document.getElementById("shopify-section-header");
        const header =
          headerSection?.querySelector("sticky-header") || headerSection;
        const root = document.documentElement;
        const ACTIVE = "product__info-config--active";

        // Writes the nav's bottom edge to --sticky-atc-top and returns it
        this.updateStickyAtcTop = () => {
          const top = header
            ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
            : 0;
          root.style.setProperty("--sticky-atc-top", `${top}px`);
          return top;
        };

        // (Re)observe the main add-to-cart button
        this.refreshStickyConfig = () => {
          this.stickyAtcObserver?.disconnect();

          const configBar = this.querySelector(".product__info-config");
          const submit = this.querySelector(
            ".add-to-cart-buttons [data-product-submit] button[type='submit']",
          );
          if (!configBar) return;
          if (!submit) {
            configBar.classList.remove(ACTIVE);
            return;
          }

          const top = this.updateStickyAtcTop();

          this.stickyAtcObserver = new IntersectionObserver(
            ([entry]) => {
              // Only when the button has scrolled up past the nav, not when
              // it's still further down the page
              const visibleTop = entry.rootBounds ? entry.rootBounds.top : top;
              const scrolledPast = entry.boundingClientRect.bottom <= visibleTop;

              const show =
                !entry.isIntersecting &&
                scrolledPast &&
                configBar.childElementCount > 0;
              if (show) this.updateStickyAtcTop(); // set position as it appears
              configBar.classList.toggle(ACTIVE, show);
            },
            // Treat the area behind the sticky header as out of view
            { rootMargin: `-${top}px 0px 0px 0px` },
          );
          this.stickyAtcObserver.observe(submit);
        };

        // Header hides/reveals on scroll (body class change): keep the bar under it
        this.stickyAtcBodyObserver = new MutationObserver(() => {
          if (this.querySelector(`.${ACTIVE}`)) this.updateStickyAtcTop();
        });
        this.stickyAtcBodyObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });

        // Viewport or header resize: recalculate and rebuild the observer
        let resizeTimer;
        this.onStickyAtcResize = () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(this.refreshStickyConfig, 150);
        };
        window.addEventListener("resize", this.onStickyAtcResize);
        if (header && "ResizeObserver" in window) {
          this.stickyAtcHeaderObserver = new ResizeObserver(
            this.onStickyAtcResize,
          );
          this.stickyAtcHeaderObserver.observe(header);
        }

        this.refreshStickyConfig();
      }

      setupTabsListener() {
        document
          .querySelectorAll(".product__expandable-tab")
          .forEach((header) => {
            header.addEventListener("click", function () {
              this.classList.toggle("active");
            });
          });
      }

      /**
       * Builds the sticky add-to-cart bar shown when the main configuration
       * scrolls out of view. The bar mirrors the live product state — image,
       * title, price, every variant option (as static labels) and the
       * add-to-cart button. Because this method re-runs on every variant
       * change (see handleUpdateProductInfo / handleSwapProduct), the bar is
       * rebuilt from the freshly-updated DOM each time, so the price and the
       * selected option values always stay in sync with the main picker.
       *
       * The option labels are read-only: they reflect the current selection
       * but don't drive it, since selection happens on the main picker.
       */
      setupStickyMobileConfig() {
        const configBar = document.querySelector(".product__info-config");
        if (!configBar) return;

        // The bar has no meaning without a buy button to drive.
        const realSubmit = document.querySelector(
          ".product .add-to-cart-buttons [data-product-submit] button[type='submit']",
        );
        if (!realSubmit) {
          configBar.innerHTML = "";
          this.refreshStickyConfig?.();
          return;
        }

        const inner = document.createElement("div");
        inner.className = "product__info-config-inner container";

        // --- Summary (image + title + price + variant options) ---------------
        const summary = document.createElement("div");
        summary.className = "product__info-config-summary";

        const activeImage =
          document.querySelector(
            ".slider-main-items li.slider__slide.is-active img",
          ) || document.querySelector(".slider-main-items li.slider__slide img");
        if (activeImage) {
          const mediaWrap = document.createElement("div");
          mediaWrap.className = "product__info-config-media-img";
          const img = document.createElement("img");
          img.src = activeImage.currentSrc || activeImage.src;
          img.alt = activeImage.alt || "";
          img.loading = "lazy";
          mediaWrap.appendChild(img);
          summary.appendChild(mediaWrap);
        }

        const headline = document.createElement("div");
        headline.className = "product__info-config-headline";

        const titleText = document
          .querySelector(".product__title h1")
          ?.textContent.trim();
        if (titleText) {
          const name = document.createElement("span");
          name.className = "product__info-config-name";
          name.textContent = titleText;
          headline.appendChild(name);
        }

        const priceEl = document.querySelector(
          ".price-details__value .product__sale-price",
        );
        if (priceEl) {
          const price = document.createElement("span");
          price.className = "product__info-config-price";
          price.textContent = priceEl.textContent.trim();
          headline.appendChild(price);
        }

        summary.appendChild(headline);

        // --- Variant option labels ---------------------------------------------
        const optionsWrap = this.buildStickyConfigOptions();
        if (optionsWrap) summary.appendChild(optionsWrap);

        inner.appendChild(summary);

        // --- Next-step message -----------------------------------------------
        const nextMessage = document
          .querySelector(".product .add-to-cart-buttons .custom-basket-subtitle")
          ?.textContent.trim();
        if (nextMessage) {
          const next = document.createElement("div");
          next.className = "product__info-config-next";
          const label = document.createElement("span");
          label.className = "product__info-config-next-label";
          label.textContent = "Next:";
          next.appendChild(label);
          next.append(` ${nextMessage}`);
          inner.appendChild(next);
        }

        // --- Add-to-cart button ----------------------------------------------
        const action = document.createElement("div");
        action.className = "product__info-config-action";
        if (nextMessage) action.classList.add("product__info-config-action--with-next");
        const button = document.createElement("button");
        button.type = "button";
        button.className =
          "product-form__submit button button--full-width button--primary";
        const buttonLabel =
          realSubmit.querySelector(".custom-basket-label")?.textContent.trim() ||
          realSubmit.textContent.trim();
        const buttonLabelEl = document.createElement("span");
        buttonLabelEl.className = "custom-basket-label";
        buttonLabelEl.textContent = buttonLabel;
        button.appendChild(buttonLabelEl);
        button.addEventListener("click", (event) => {
          event.preventDefault();
          realSubmit.click();
        });
        action.appendChild(button);
        inner.appendChild(action);

        // Render and keep the bar's button in step with the real one (sold out,
        // unavailable, etc.).
        configBar.innerHTML = "";
        configBar.appendChild(inner);
        this.addToBasketButtonStateSync(realSubmit, button);
        this.refreshStickyConfig?.();
      }

      /**
       * Builds a row of static labels, one per variant option, showing the
       * currently selected value. Read-only: the sticky bar mirrors the
       * picker's state rather than driving it.
       *
       * @returns {HTMLElement|null} The options container, or null when the
       *   product has no selectable options.
       */
      buildStickyConfigOptions() {
        const picker = document.querySelector(
          "product-info variant-radios, product-info variant-selects",
        );
        if (!picker) return null;

        const controls = picker.querySelectorAll('[name^="options["]');
        if (!controls.length) return null;

        // Group the real controls by their option name. Native selects are a
        // group of one; radio swatches share a name across the group.
        const groups = new Map();
        controls.forEach((control) => {
          const name = control.getAttribute("name");
          if (control.tagName === "SELECT") {
            groups.set(name, { kind: "select", el: control });
          } else if (control.type === "radio") {
            const group = groups.get(name) || { kind: "radio", radios: [] };
            group.radios.push(control);
            groups.set(name, group);
          }
        });
        if (!groups.size) return null;

        const optionsWrap = document.createElement("div");
        optionsWrap.className = "product__info-config-options";

        groups.forEach((group, name) => {
          const optionName = name.replace(/^options\[/, "").replace(/\]$/, "");

          let selectedValue = "";
          if (group.kind === "select") {
            selectedValue = group.el.options[group.el.selectedIndex]
              ? group.el.options[group.el.selectedIndex].textContent.trim()
              : "";
          } else {
            const checked = group.radios.find((radio) => radio.checked);
            selectedValue = checked ? checked.value : "";
          }
          if (!selectedValue) return;

          const field = document.createElement("div");
          field.className = "product__info-config-option";

          const label = document.createElement("span");
          label.className = "product__info-config-value";
          label.setAttribute("aria-label", optionName);
          label.textContent = selectedValue;

          field.appendChild(label);
          optionsWrap.appendChild(field);
        });

        return optionsWrap.children.length ? optionsWrap : null;
      }

      /**
       * Synchronises the disabled state of the sticky bar's add-to-cart button
       * with the real submit button in the main product form, using a
       * MutationObserver on the original button's `disabled` attribute.
       *
       * @param {HTMLElement} originalButton - The real submit button in the main product form.
       * @param {HTMLElement} clonedButton - The sticky bar's add-to-cart button.
       *
       * @returns {MutationObserver} The MutationObserver instance observing/disconnecting the original button.
       */
      addToBasketButtonStateSync(originalButton, clonedButton) {
        // Check if both buttons exists and are instance of DOM elements before setting up the observer
        if (!originalButton || !clonedButton) return;
        if (!(originalButton instanceof HTMLElement) || !(clonedButton instanceof HTMLElement)) return;

        // Listen for any DOM changes to the original button to update the cloned button's disabled state accordingly
        const observer = new MutationObserver(() => {
          if (originalButton) {
            clonedButton.disabled = originalButton.disabled;
          }
        });

        // Initialize the cloned button's disabled state to match the original button
        clonedButton.disabled = originalButton.disabled;

        observer.observe(originalButton, {
          attributes: true,
          attributeFilter: ["disabled"],
        });

        // return the observer instance in case we need to disconnect it later
        return observer;
      }

      initMobileSliderDragEvent() {
        const dragArea = document.querySelector(
          ".slider-main-items ul.product__media-list",
        );
        let startX = 0;
        let endX = 0;
        let isDragging = false;

        dragArea.addEventListener("mousedown", (e) => {
          startX = e.clientX;
          isDragging = true;
        });

        window.addEventListener("mouseup", () => {
          if (!isDragging) return;
          isDragging = false;
          const mobNav = document.querySelector(".slider-mobile-nav");
          const isMobile = window.innerWidth < 820;

          if (endX > startX) {
            isMobile && mobNav.getPrevOrNextSlide(false);
          } else if (endX < startX) {
            isMobile && mobNav.getPrevOrNextSlide(true);
          }
        });

        window.addEventListener("mousemove", (e) => {
          if (!isDragging) return;
          endX = e.clientX;
        });
      }

      setupSmartbaseWidths() {
        function setEqualWidths() {
          const flexItems = document.querySelectorAll(
            ".product .p-custom-swatch--smartbase label",
          );
          let maxWidth = 0;

          flexItems.forEach((item) => {
            item.style.width = "auto";
          });

          flexItems.forEach((item) => {
            const itemWidth = item.offsetWidth;
            if (itemWidth > maxWidth) {
              maxWidth = itemWidth;
            }
          });

          flexItems.forEach((item) => {
            if (flexItems.length < 2) {
              if (window.innerWidth <= 1535) {
                item.setAttribute(
                  "style",
                  `width: calc(50% - .7rem) !important;`,
                );
              } else {
                item.style.width = `${maxWidth}px`;
              }
            } else {
              if (window.innerWidth >= 990 && window.innerWidth <= 1280) {
                item.setAttribute("style", `width: 100% !important;`);
              } else if (window.innerWidth < 580) {
                item.setAttribute("style", `width: 100% !important;`);
              } else {
                item.setAttribute(
                  "style",
                  `width: calc(50% - .7rem) !important;`,
                );
              }
            }
          });
        }

        function debounce(func, delay) {
          let timer;
          return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
          };
        }

        setEqualWidths();

        const debouncedSetEqualWidths = debounce(setEqualWidths, 200);
        window.addEventListener("resize", debouncedSetEqualWidths);
      }

      checkProductReviewAndSample() {
        const targetElement = document.querySelector(
          ".product-trustpilot-badge .trustpilot-widget",
        );

        if (targetElement) {
          const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
              if (mutation.type === "childList") {
                const iframes = targetElement.querySelectorAll("iframe");

                if (iframes.length === 2) {
                  const targetStyle = targetElement.getAttribute("style");
                  const targetNewStyle = String(targetStyle).replace(
                    "display: none;",
                    "",
                  );
                  targetElement.setAttribute("style", targetNewStyle);
                  observer.disconnect();
                } else {
                  const targetStyle = targetElement.getAttribute("style") || "";
                  if (!targetStyle.includes("display: none;")) {
                    const targetNewStyle = `${targetStyle}display: none;`;
                    targetElement.setAttribute("style", targetNewStyle);
                  }
                }
              }
            });
          });

          observer.observe(targetElement, { childList: true, subtree: true });
        }

        // Handle swatch--sample elements
        const swatches = document.querySelectorAll(".swatch--sample");
        if (swatches.length > 1) {
          swatches.forEach((swatch, index) => {
            if (index !== swatches.length - 1) {
              swatch.style.display = "none";
            }
          });
        }

        // Handle square-icon elements
        const squareIcons = document.querySelectorAll(".square-icon");
        if (squareIcons.length > 1) {
          squareIcons.forEach((icon, index) => {
            if (index !== squareIcons.length - 1) {
              icon.style.display = "none";
            }
          });
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products",
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`,
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list",
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}
